const AnimatedHeroCopy = {
  parts: [
    'container',
    'wrapper',
    'text'
  ],
  baseStyle: {
    container: {
      px: {base: 5, lg: 20},
      py: {base: 5, lg: 0},
      maxWidth: '1440px',
      mx: 'auto',
      sx: {
        '&:last-child': {
          pb: {base: 5, lg: 20},
        },
      },
    },
    wrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      maxWidth: '620px',
      mx: 'auto',
    },
    text: {
      color: 'brandColors.greyscale90',
      fontSize: {base: 'md', lg: 'lg'},
      fontStyle: 'normal',
      fontWeight: 'normal',
      lineHeight: '160%',
      sx: {
        ' h3': {
          fontSize: {base: '22px', lg: '32px'},
          fontStyle: 'normal',
          fontWeight: '500',
          lineHeight: '120%',
          letterSpacing: {base: '-0.22px', lg: '0'},
          mb: {base: 3, lg: 4},
        },
        ' p': {
          mb: 10,
        },
        ' p:last-child': {
          mb: 0,
        },
        ' blockquote': {
          fontSize: {base: 'xl', lg: '28px'},
          fontStyle: 'normal',
          fontWeight: 'normal',
          lineHeight: {base: '150%', lg: '140%'},
          pl: {base: 6, lg: 8},
          borderLeft: '4px solid',
          borderColor: 'brandColors.primaryDarkLinen',
        },
      },
    },
  },
};

export default AnimatedHeroCopy;
